
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/living/agenda",
      function () {
        return require("private-next-pages/world/living/agenda.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/living/agenda"])
      });
    }
  